<template>
  <v-dialog
    v-model="dialog"
    scrollable
    width="450"
    persistent
  >
    <v-card
      flat
      tile
    >
      <v-toolbar
        dense
        light
        class="grey lighten-2"
      >
        <v-toolbar-title class="text-body-1 font-weight-bold">
          {{ $t('m.personalProfile') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          color=""
          @click="handleCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-progress-linear
          :active="isLoading"
          :indeterminate="isLoading"
          absolute
          bottom
          color="deep-purple accent-4"
        />
      </v-toolbar>

      <v-container
        fluid
        class="px-0 py-2"
      >
        <v-card
          flat
          tile
          class="px-8"
          :height="workspaceCardHeight"
          style="overflow-y:auto;"
        >
          <v-card
            class="py-3 mt-1"
            flat
            tile
          >
            <div class="mb-3 font-weight-black text-subtitle-2">
              {{ $t("m.personalInfo") }}
            </div>
            <v-text-field
              dense
              outlined
              v-model="OperName"
              :label="$t('m.nickname')"
              :error-messages="OperNameErrors"
              @input="$v.OperName.$touch()"
              @blur="$v.OperName.$touch()"
            />

            <v-text-field
              dense
              outlined
              v-model="RealName"
              :label="$t('m.realName')"
              :error-messages="RealNameErrors"
              @input="$v.RealName.$touch()"
              @blur="$v.RealName.$touch()"
            />

            <v-text-field
              dense
              outlined
              v-model="Mobile"
              :label="$t('m.mobile')"
              :error-messages="MobileErrors"
              @input="$v.Mobile.$touch()"
              @blur="$v.Mobile.$touch()"
            />

            <v-text-field
              dense
              outlined
              v-model="Skype"
              label="Skype"
            />

            <v-text-field
              dense
              outlined
              v-model="QQ"
              label="QQ"
            />

            <v-select
              :items="sexArr"
              :label="$t('m.gender')"
              outlined
              dense
              v-model="Sex"
              item-text="text"
              item-value="val"
            />

            <v-textarea
              outlined
              rows="6"
              :label="$t('m.aboutMe')"
              placeholder="Hold Size"
              v-model="AboutMe"
            />
          </v-card> <!-- end 基本信息 -->

          <v-card
            class="pb-2"
            flat
            tile
          >
            <div class="mb-3 font-weight-black text-subtitle-2">
              {{ $t("m.companyInformation") }}
            </div>
            <v-text-field
              dense
              outlined
              v-model="CorporationName"
              :label="$t('m.company')"
              :error-messages="CorporationNameErrors"
              @input="$v.CorporationName.$touch()"
              @blur="$v.CorporationName.$touch()"
            />

            <v-text-field
              dense
              outlined
              v-model="JobTitle"
              :label="$t('m.title')"
            />

            <v-text-field
              dense
              outlined
              v-model="DepartName"
              :label="$t('m.department')"
            />

            <v-select
              :items="countryArr"
              :label="$t('m.nation')"
              outlined
              dense
              v-model="CountryCode"
              item-text="COUNTRYNAME"
              item-value="COUNTRYCODE"
            />

            <v-text-field
              dense
              outlined
              v-model="OfficeTel"
              :label="$t('m.tel')"
            />

            <v-text-field
              dense
              outlined
              v-model="City"
              :label="$t('m.city')"
            />

            <v-text-field
              dense
              outlined
              v-model="Address"
              :label="$t('m.address')"
            />
          </v-card> <!-- end 公司信息 -->

          <v-btn
            block
            class="mb-5"
            :disabled="isLoading"
            depressed
            color="success"
            @click="save"
          >
            {{ $t('m.submit') }}
          </v-btn>
        </v-card>
      </v-container>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <v-snackbar
      v-model="snackbar"
      centered
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'OperBaseInfoEditDialog',
  mixins: [validationMixin],
  components: {
  },
  props: [
    'visible'
  ],
  data () {
    return {
      dialog: false,

      value: [0, 1],
      isLoading: false,
      btnDisabled: false,
      snackbar: false,
      snackbarText: null,

      userInfo: {},
      OperName: '',
      RealName: '',
      Mobile: '',
      Skype: '',
      QQ: '',
      Sex: '',
      AboutMe: '',
      CorporationName: '',
      JobTitle: '',
      DepartName: '',
      OfficeTel: '',
      CountryCode: '',
      City: '',
      Address: '',
      sexArr: [{
        val: '', text: this.$t('m.pleaseChoose')
      }, {
        val: '1', text: this.$t('m.male')
      }, {
        val: '2', text: this.$t('m.female')
      }
      ]
    }
  },

  validations: {
    OperName: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(16),
      async isUnique (value) {
        if (value.length < 4 || value.length > 16) return true
        var params = {
          OperName: value,
          OperID: Utils.getWithExpiry('operID'),
          CheckFlag: '2'
        }
        const response = await httpClient.get('/auth/OPUserOperNameCheck'
          , { params: params })
        return Boolean(response.data === 0)
      }
    },
    RealName: { required },
    Mobile: { required },
    CorporationName: { required, minLength: minLength(6), maxLength: maxLength(60) }
  },

  computed: {
    ...mapState({
      countryArr: state => state.commons.countryArr
    }),

    OperNameErrors () {
      const errors = []
      if (!this.$v.OperName.$dirty) return errors
      !this.$v.OperName.required && errors.push(this.$t('m.required'))
      !this.$v.OperName.minLength && errors.push(this.$t('m.nicknameInvalid'))
      !this.$v.OperName.maxLength && errors.push(this.$t('m.nicknameInvalid'))
      !this.$v.OperName.isUnique && errors.push(this.$t('m.nicknameBeUsed'))
      return errors
    },

    RealNameErrors () {
      const errors = []
      if (!this.$v.RealName.$dirty) return errors
      !this.$v.RealName.required && errors.push(this.$t('m.required'))
      return errors
    },

    MobileErrors () {
      const errors = []
      if (!this.$v.Mobile.$dirty) return errors
      !this.$v.Mobile.required && errors.push(this.$t('m.required'))
      return errors
    },

    CorporationNameErrors () {
      const errors = []
      if (!this.$v.CorporationName.$dirty) return errors
      !this.$v.CorporationName.required && errors.push(this.$t('m.required'))
      !this.$v.CorporationName.minLength && errors.push(this.$t('m.companyInvalid'))
      !this.$v.CorporationName.maxLength && errors.push(this.$t('m.companyInvalid'))
      return errors
    },

    workspaceCardHeight () {
      if (this.$vuetify.breakpoint.height > 859) {
        return 'auto'
      }
      return this.$vuetify.breakpoint.height - 150
    }

  },
  watch: {
    visible: function (val) {
      this.query()
      this.dialog = val
    }
  },
  created () {

  },
  methods: {
    handleCancel () {
      this.dialog = false
      this.clear()
      this.$emit('cancel')
    },

    query () {
      this.isLoading = true
      var json = {
        OperID: Utils.getWithExpiry('operID')
      }
      httpClient.post('/OPUserRegInfoQryByOperID', json)
        .then((res) => {
          if (res.data.message) {
            this.userInfo = res.data.message
            this.OperName = this.userInfo.operName
            this.RealName = this.userInfo.realName
            this.Mobile = this.userInfo.mobile
            this.Skype = this.userInfo.skype
            this.QQ = this.userInfo.qq
            this.Wechat = this.userInfo.wechat
            this.Sex = this.userInfo.sex
            this.AboutMe = this.userInfo.aboutMe

            this.CorporationName = this.userInfo.corporationName
            this.JobTitle = this.userInfo.jobTitle
            this.DepartName = this.userInfo.departName
            this.CountryCode = this.userInfo.countryCode
            this.OfficeTel = this.userInfo.officeTel
            this.City = this.userInfo.city
            this.Address = this.userInfo.address
            // this.ConcernDomain = this.userInfo.concernDomain.split(',')
          }
          this.isLoading = false
        }).catch((err) => {
          this.isLoading = false
        })
    },

    save () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoading = true
      var postJson = {
        OperID: Utils.getWithExpiry('operID'),

        OperName: this.OperName,
        RealName: this.RealName,
        Mobile: this.Mobile,
        Skype: this.Skype,
        QQ: this.QQ,
        Sex: this.Sex,
        AboutMe: this.AboutMe,
        CorporationName: this.CorporationName,
        JobTitle: this.JobTitle,
        DepartName: this.DepartName,
        CountryCode: this.CountryCode,
        OfficeTel: this.OfficeTel,
        City: this.City,
        Address: this.Address,

        ConcernDomain: this.userInfo.concernDomain
      }

      httpClient.post('/OPUserInfoEdit', postJson)
        .then((res) => {
          Utils.setWithExpiry('operName', postJson.OperName
            , Constant.LOCALSTORAGE_EXPIRY_PERIOD)
          this.isLoading = false
          this.$emit('save')
        }).catch((err) => {
          this.isLoading = false
        })
    },

    clear () {
      this.$v.$reset()
    }

  }
}
</script>

<style scoped lang="scss">

</style>
